import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Model, { attr, hasMany, belongsTo } from '@ember-data/model';
import { inject } from '@ember/service';
import { cached, tracked } from '@glimmer/tracking';
import { _saveAll, _safeReload, _sortedCustomFields } from '../lib/utility.js';

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31;
let WorkhourModel = (_dec = attr('boolean'), _dec2 = attr('string'), _dec3 = attr('string'), _dec4 = attr('number'), _dec5 = attr('string'), _dec6 = attr('string'), _dec7 = attr('boolean'), _dec8 = attr('number'), _dec9 = attr('number'), _dec0 = hasMany('workhour', {
  inverse: null,
  async: true
}), _dec1 = hasMany('contact', {
  inverse: null,
  async: true
}), _dec10 = hasMany('product', {
  inverse: null,
  async: true
}), _dec11 = hasMany('project', {
  inverse: null,
  async: true
}), _dec12 = hasMany('event', {
  inverse: null,
  async: true
}), _dec13 = hasMany('invoice', {
  inverse: null,
  async: true
}), _dec14 = hasMany('expense', {
  inverse: null,
  async: true
}), _dec15 = hasMany('address', {
  inverse: null,
  async: false
}), _dec16 = belongsTo('workhour_state', {
  inverse: null,
  async: false
}), _dec17 = hasMany('custom_field', {
  inverse: null,
  async: false
}), _dec18 = hasMany('file', {
  inverse: null,
  async: true
}), _dec19 = attr('number', {
  defaultValue: 0
}), _dec20 = attr('number', {
  defaultValue: 0
}), _dec21 = attr('number', {
  defaultValue: 0
}), _dec22 = attr('number', {
  defaultValue: 0
}), _dec23 = attr('number', {
  defaultValue: 0
}), _dec24 = attr('number', {
  defaultValue: 0
}), _dec25 = attr('number', {
  defaultValue: 0
}), _dec26 = attr('number', {
  defaultValue: 0
}), _dec27 = hasMany('contact', {
  inverse: null,
  async: false
}), _dec28 = attr('boolean', {
  defaultValue: false
}), _class = class WorkhourModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "session", _descriptor2, this);
    _initializerDefineProperty(this, "checked", _descriptor3, this);
    _initializerDefineProperty(this, "archivied", _descriptor4, this);
    _initializerDefineProperty(this, "created_at", _descriptor5, this);
    _initializerDefineProperty(this, "date", _descriptor6, this);
    _initializerDefineProperty(this, "duration", _descriptor7, this);
    _initializerDefineProperty(this, "text", _descriptor8, this);
    _initializerDefineProperty(this, "notes", _descriptor9, this);
    _initializerDefineProperty(this, "boolean_field", _descriptor0, this);
    _initializerDefineProperty(this, "price", _descriptor1, this);
    _initializerDefineProperty(this, "cost", _descriptor10, this);
    _initializerDefineProperty(this, "related_workhours", _descriptor11, this);
    _initializerDefineProperty(this, "contacts", _descriptor12, this);
    _initializerDefineProperty(this, "products", _descriptor13, this);
    _initializerDefineProperty(this, "projects", _descriptor14, this);
    _initializerDefineProperty(this, "events", _descriptor15, this);
    _initializerDefineProperty(this, "invoices", _descriptor16, this);
    _initializerDefineProperty(this, "expenses", _descriptor17, this);
    _initializerDefineProperty(this, "addresses", _descriptor18, this);
    _initializerDefineProperty(this, "workhour_state", _descriptor19, this);
    _initializerDefineProperty(this, "custom_fields", _descriptor20, this);
    _initializerDefineProperty(this, "files", _descriptor21, this);
    _initializerDefineProperty(this, "total_files_number", _descriptor22, this);
    _initializerDefineProperty(this, "total_contacts_number", _descriptor23, this);
    _initializerDefineProperty(this, "total_products_number", _descriptor24, this);
    _initializerDefineProperty(this, "total_projects_number", _descriptor25, this);
    _initializerDefineProperty(this, "total_expenses_number", _descriptor26, this);
    _initializerDefineProperty(this, "total_invoices_number", _descriptor27, this);
    _initializerDefineProperty(this, "total_events_number", _descriptor28, this);
    _initializerDefineProperty(this, "total_related_workhours_number", _descriptor29, this);
    _initializerDefineProperty(this, "current_users", _descriptor30, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor31, this);
  }
  get idArray() {
    return [this.id];
  }
  saveAll(model) {
    return _saveAll(model, this.session, 'workhours_all');
  }
  safeReload() {
    return _safeReload(this);
  }
  get sorted_custom_fields() {
    let fields;
    try {
      fields = this.custom_fields;
    } catch {
      return [];
    }
    if (Array.isArray(fields)) {
      return _sortedCustomFields(fields, this.isDeleted);
    }
    if (fields && typeof fields.then === 'function') {
      return fields.then(resolvedFields => _sortedCustomFields(resolvedFields, this.isDeleted));
    }
    return [];
  }
  get label() {
    const timeZone = this.session?.me?.time_zone || 'Europe/Rome';
    const dateObject = this.date ? new Date(this.date) : null;
    if (dateObject && !isNaN(dateObject.getTime())) {
      const formattedDate = this.intl.formatDate(dateObject, {
        timeZone: timeZone,
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
      return formattedDate;
    }
    return '';
  }
  get sub_label() {
    return this.text || this.intl.t('no title');
  }
  get status_name() {
    return this.workhour_state?.status_name;
  }
  get firstLetters() {
    const name = this.text || '';
    const words = name.trim().split(' ');
    const initials = words.filter(word => word.length > 0).slice(0, 3).map(word => word[0].toUpperCase()).join('');
    return initials || '-';
  }
  get firstLetter() {
    if (this.text && this.text.length > 0) {
      return this.text[0].toLowerCase();
    }
    return '';
  }
  get current_users_label() {
    return this.current_users.map(user => user.label).join(' ');
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "session", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "checked", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "archivied", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "created_at", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "date", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "duration", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "text", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "notes", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "boolean_field", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "price", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "cost", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "related_workhours", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "contacts", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "products", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "projects", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "events", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "invoices", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "expenses", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "addresses", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "workhour_state", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "custom_fields", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "sorted_custom_fields", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "sorted_custom_fields"), _class.prototype), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "files", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "total_files_number", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "total_contacts_number", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "total_products_number", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "total_projects_number", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "total_expenses_number", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "total_invoices_number", [_dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "total_events_number", [_dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "total_related_workhours_number", [_dec26], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "current_users", [_dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec28], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { WorkhourModel as default };
//# sourceMappingURL=workhour.js.map
